<template>
    <v-dialog v-model="dialog" width="auto" content-class="confirmAssign-dialog">
        <div class="confirmAssign-container">
            <button class="close" @click.prevent="no">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </button>
            <div class="confirmAssign_body" :style="`width: ${dialogBodyWidth}px; max-height: ${dialogBodyHeight}px;`">
                <h1 class="grade_item-name">Подтверждение</h1>
                <div class="body-container">
                    <p>Текущее задание не будет назначено перечисленным студентам, так как оно было назначено им ранее.</p>
                    <ul ref="studentsList" :style="`max-height: ${listHeight}px;`">
                        <li v-for="(student) in students" :key="student.id">{{ student.fio }}</li>
                    </ul>
                    <p>Продолжить?</p>
                    <div class="confirm_btn-wrap">
                        <button @click.prevent="yes" class="confirm_btn">Да</button>
                        <button @click.prevent="no" class="confirm_btn">Нет</button>
                    </div>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: 'confirmAssignDialog',
    data: () => ({
        students: [],
        dialogBodyWidth: 0,
        dialogBodyHeight: 0,
        listHeight: 0,
        dialog: false
    }),
    methods: {
        open(students) {
            this.dialog = true;
            this.students = students;

            this.$nextTick(() => {
                this.$refs.studentsList.scrollTop = 0;
            });
        },
        yes() {
            this.dialog = false;
            this.$emit('yes');
        },
        no() {
            this.dialog = false;
        }
    },
    created() {
        let margin = 48;
        let buttonSize = 36;

        this.dialogBodyWidth = 600;
        let dialogWidth = this.dialogBodyWidth + margin + buttonSize;

        if (dialogWidth > window.innerWidth) {
            this.dialogBodyWidth = window.innerWidth - margin - buttonSize;
        }

        this.dialogBodyHeight = Math.floor(window.innerHeight * 0.9) - buttonSize;
        this.listHeight = this.dialogBodyHeight - 271;
    }
}
</script>

<style lang="scss" scoped>
.confirmAssign-dialog {
    box-shadow: none;
    .confirmAssign-container {
        display: grid;
        justify-content: center;
        align-items: center;
        grid-template-columns: 1fr 36px;
        grid-template-rows: 36px 1fr;
        .close {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border-radius: 12px;
            background: #F3F4F6;
            grid-column: 2/2;
            grid-row: 1/1;
        }
        .confirmAssign_body {
            display: flex;
            grid-column: 1/1;
            grid-row: 2/2;
            padding: 32px;
            flex-direction: column;
            align-items: flex-start;
            border-radius: 12px;
            background: #FFF;
            h1 {
                color: #000;
                font-family: Inter;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: 18px; /* 69.231% */
            }
            .body-container {
                width: 100%;
                margin-top: 24px;
                overflow: auto;
                ul {
                    margin-bottom: 16px;
                    overflow: auto;
                }
                .confirm_btn-wrap {
                    display: flex;
                    gap: 16px;
                    justify-content: center;
                    .confirm_btn {
                        width: 74px;
                        padding: 12px 24px;
                        border-radius: 12px;
                        font-family: Inter;
                        font-size: 14px;
                        background-color: #4854FE;
                        color: #FFF;
                    }
                }
            }
        }
    }
}
</style>
